import { Button, Modal } from "react-bootstrap";


const ModalView = ({title, message, shouldShow, onClose, confirmTitle, onConfirm}:
	{title?:string, message?:string, shouldShow:boolean, onClose:()=>void, confirmTitle?:string, onConfirm:()=>void}) => {

	return (
		<Modal show={shouldShow} onHide={onClose}>
			<Modal.Header closeButton>
				<Modal.Title>{title && title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>{message && message}</Modal.Body>
			<Modal.Footer>
				<Button variant="primary" onClick={onConfirm}>
					{confirmTitle && confirmTitle}
				</Button>
			</Modal.Footer>
      	</Modal>
	)
}

export default ModalView;